import React from "react";
import "leaflet.fullscreen/Control.FullScreen.css";
import "leaflet.fullscreen";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import { FaEdit, FaTrashAlt, FaUserCircle } from "react-icons/fa";
import { applyTailwindClasses } from "../../utils/popupUtils.js";

export default function PinPopup({ pin, user, canEdit, onEdit, onDelete }) {
	return (
		<div className="min-w-[300px] min-h-[50px]">
			<h3 className="text-lg font-semibold text-center mb-6 border-b bp-">{pin.title}</h3>
			<div
				dangerouslySetInnerHTML={{
					__html: applyTailwindClasses(pin.html),
				}}
			/>
			{user && canEdit && (
				<div className="mt-5 flex justify-between items-center">
					<div className="flex gap-2">
						<button
							id="edit"
							aria-label="Modifica"
							className="flex items-center bg-blue-500 text-white p-2 rounded hover:bg-blue-600"
							onClick={onEdit}
						>
							<FaEdit />
						</button>
						<button
							id="delete"
							aria-label="Elimina"
							className="flex items-center bg-red-500 text-white p-2 rounded hover:bg-red-600"
							onClick={onDelete}
						>
							<FaTrashAlt />
						</button>
					</div>
					{(pin.created_by || pin.updated_by) && (
						<div className="relative group">
							<FaUserCircle className="text-gray-600 text-xl cursor-pointer" />
							<div className="min-w-56 absolute right-0 top-full mt-1 p-2 bg-white shadow-lg border rounded hidden group-hover:block">
								{pin.created_by && (
									<p className="text-sm text-gray-700">
										<strong>Creato da:</strong> {pin.created_by}
									</p>
								)}
								{pin.updated_by && (
									<p className="text-sm text-gray-700">
										<strong>Aggiornato da:</strong> {pin.updated_by}
									</p>
								)}
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
